/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: User_Accounts JSON Schemas 

const _ADMIN_GHOST_USER_ACCOUNT_JSON_SCHEMA = {
    "$ref": "#/definitions/AdminGhostUserAccountSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "AdminGhostUserAccountSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "currently_in_use": {
                    "title": "Currently In Use",
                    "type": "boolean"
                },
                "ghost_account_uid": {
                    "reference_type": "uuid",
                    "title": "Ghost Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account_admin_ghost"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "set_by_admin_account_uid": {
                    "reference_type": "uuid",
                    "title": "Set By Admin Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "target_account_uid": {
                    "reference_type": "uuid",
                    "title": "Target Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "created_timestamp",
                "currently_in_use",
                "last_updated_timestamp",
                "set_by_admin_account_uid",
                "target_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _ARCHIVED_PENDING_EMAIL_CHANGE_JSON_SCHEMA = {
    "$ref": "#/definitions/ArchivedPendingEmailChangeSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ArchivedPendingEmailChangeSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "change_uid": {
                    "reference_type": "uuid",
                    "title": "Change Uid",
                    "type": "string",
                    "uid_resource_type": "pending_email_change"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "last_sent_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Sent Email Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "pending_email_change_created_timestamp": {
                    "format": "date-time",
                    "title": "Pending Email Change Created Timestamp",
                    "type": "string"
                },
                "pending_email_change_last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Pending Email Change Last Updated Timestamp",
                    "type": "string"
                },
                "sent_email_count": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Sent Email Count",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "change_uid",
                "created_timestamp",
                "email_address",
                "email_hash",
                "last_sent_email_timestamp",
                "last_updated_timestamp",
                "pending_email_change_created_timestamp",
                "pending_email_change_last_updated_timestamp",
                "sent_email_count"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BALANCE_CHANGE_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/BalanceChangeLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BalanceChangeLogSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "change_log_uid": {
                    "reference_type": "uuid",
                    "title": "Change Log Uid",
                    "type": "string",
                    "uid_resource_type": "balance_change_log"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "delta_free_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Delta Free Balance In Cents",
                    "type": "number"
                },
                "delta_locked_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Delta Locked Balance In Cents",
                    "type": "number"
                },
                "delta_total_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Delta Total Balance In Cents",
                    "type": "number"
                },
                "entry_type": {
                    "class_name": "BalanceChangeLogEntryType",
                    "enum": [
                        "standard",
                        "rollback"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "new_free_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "New Free Balance In Cents",
                    "type": "number"
                },
                "new_locked_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "New Locked Balance In Cents",
                    "type": "number"
                },
                "new_total_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "New Total Balance In Cents",
                    "type": "number"
                },
                "notes": {
                    "maxLength": 2048,
                    "title": "Notes",
                    "type": "string"
                },
                "previous_free_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Previous Free Balance In Cents",
                    "type": "number"
                },
                "previous_locked_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Previous Locked Balance In Cents",
                    "type": "number"
                },
                "previous_total_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Previous Total Balance In Cents",
                    "type": "number"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "change_log_uid",
                "created_timestamp",
                "delta_free_balance_in_cents",
                "delta_locked_balance_in_cents",
                "delta_total_balance_in_cents",
                "entry_type",
                "last_updated_timestamp",
                "new_free_balance_in_cents",
                "new_locked_balance_in_cents",
                "new_total_balance_in_cents",
                "notes",
                "previous_free_balance_in_cents",
                "previous_locked_balance_in_cents",
                "previous_total_balance_in_cents",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BALANCE_SOURCE_TRANSFER_JSON_SCHEMA = {
    "$ref": "#/definitions/BalanceSourceTransferSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BalanceSourceTransferSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "balance_source_uid": {
                    "reference_type": "uuid",
                    "title": "Balance Source Uid",
                    "type": "string",
                    "uid_resource_type": "balance_source_transfer"
                },
                "bulk_transfer_uid": {
                    "reference_type": "uuid",
                    "title": "Bulk Transfer Uid",
                    "type": "string",
                    "uid_resource_type": "bulk_funds_transfer"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "funds_destination": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_destination_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Destination Uid",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "transfer_uid": {
                    "reference_type": "uuid",
                    "title": "Transfer Uid",
                    "type": "string",
                    "uid_resource_type": "balance_source_transfer"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "balance_source_uid",
                "bulk_transfer_uid",
                "created_timestamp",
                "funds_destination",
                "funds_destination_uid",
                "funds_location",
                "funds_location_uid",
                "last_updated_timestamp",
                "transfer_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _CREDIT_USER_ACCOUNT_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/CreditUserAccountLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "CreditUserAccountLogSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "credit_log_uid": {
                    "reference_type": "uuid",
                    "title": "Credit Log Uid",
                    "type": "string",
                    "uid_resource_type": "credit_user_account_log"
                },
                "credit_type": {
                    "class_name": "CreditType",
                    "enum": [
                        "funds_added_via_payment_provider",
                        "funds_lock_release",
                        "deposit_interest",
                        "funds_transfer",
                        "deposify_credit",
                        "fees_refund",
                        "refund"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "credit_log_uid",
                "credit_type",
                "funds_location",
                "funds_location_uid",
                "last_updated_timestamp",
                "notes_uid",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EMAIL_VERIFICATION_JSON_SCHEMA = {
    "$ref": "#/definitions/EmailVerificationSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EmailVerificationSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "last_sent_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Sent Email Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "sent_email_count": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Sent Email Count",
                    "type": "number"
                },
                "token_hash": {
                    "title": "Token Hash",
                    "type": "string"
                },
                "verification_token": {
                    "title": "Verification Token",
                    "type": "string"
                },
                "verification_type": {
                    "class_name": "EmailVerificationType",
                    "enum": [
                        "new_account",
                        "email_address_change"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "verification_uid": {
                    "reference_type": "uuid",
                    "title": "Verification Uid",
                    "type": "string",
                    "uid_resource_type": "email_verification_record"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "last_sent_email_timestamp",
                "last_updated_timestamp",
                "sent_email_count",
                "token_hash",
                "verification_token",
                "verification_type",
                "verification_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EMAIL_VERIFICATION_RECORD_JSON_SCHEMA = {
    "$ref": "#/definitions/EmailVerificationRecordSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EmailVerificationRecordSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "record_type": {
                    "class_name": "EmailVerificationRecordType",
                    "enum": [
                        "verified_by_email",
                        "organization_verified",
                        "admin_verified"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "sent_email_count": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Sent Email Count",
                    "type": "number"
                },
                "token_hash": {
                    "title": "Token Hash",
                    "type": "string"
                },
                "verification_token": {
                    "title": "Verification Token",
                    "type": "string"
                },
                "verification_type": {
                    "class_name": "EmailVerificationType",
                    "enum": [
                        "new_account",
                        "email_address_change"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "verification_uid": {
                    "reference_type": "uuid",
                    "title": "Verification Uid",
                    "type": "string",
                    "uid_resource_type": "email_verification_record"
                },
                "verified_timestamp": {
                    "format": "date-time",
                    "title": "Verified Timestamp",
                    "type": "string"
                },
                "verifying_resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "verifying_resource_uid": {
                    "reference_type": "uuid",
                    "title": "Verifying Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "last_updated_timestamp",
                "record_type",
                "sent_email_count",
                "token_hash",
                "verification_token",
                "verification_type",
                "verification_uid",
                "verified_timestamp",
                "verifying_resource_type",
                "verifying_resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EXPIRED_PASSWORD_JSON_SCHEMA = {
    "$ref": "#/definitions/ExpiredPasswordSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ExpiredPasswordSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "expired_password_uid": {
                    "reference_type": "uuid",
                    "title": "Expired Password Uid",
                    "type": "string",
                    "uid_resource_type": "expired_password"
                },
                "expired_reason": {
                    "class_name": "ExpiredPasswordReason",
                    "enum": [
                        "password_reset",
                        "user_updated_password",
                        "admin_triggered_reset",
                        "admin_changed",
                        "mandatory_update"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "password_hash": {
                    "title": "Password Hash",
                    "type": "string"
                },
                "password_salt": {
                    "title": "Password Salt",
                    "type": "string"
                },
                "password_version": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Password Version",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "expired_password_uid",
                "expired_reason",
                "last_updated_timestamp",
                "password_hash",
                "password_salt",
                "password_version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _FUNDS_LOCK_JSON_SCHEMA = {
    "$ref": "#/definitions/FundsLockSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "FundsLockSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "lock_uid": {
                    "reference_type": "uuid",
                    "title": "Lock Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock"
                },
                "locked_balance_source_list": {
                    "items": {
                        "title": "locked_balance_source_list",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Locked Balance Source List",
                    "type": "array",
                    "uid_resource_type": "user_account_balance_source"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "deposify_tags",
                "last_updated_timestamp",
                "lock_uid",
                "locked_balance_source_list",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _FUNDS_LOCK_RELEASE_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/FundsLockReleaseLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "FundsLockReleaseLogSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "funds_lock_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Lock Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "release_log_uid": {
                    "reference_type": "uuid",
                    "title": "Release Log Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock_release_log"
                },
                "release_type": {
                    "class_name": "FundsLockReleaseType",
                    "enum": [
                        "release_with_returns",
                        "no_returns",
                        "user_withdraw_request_cancelled",
                        "user_withdraw_request_edited"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "funds_lock_uid",
                "last_updated_timestamp",
                "release_log_uid",
                "release_type"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _INTERNATIONAL_USER_BANK_ACCOUNT_JSON_SCHEMA = {
    "$ref": "#/definitions/InternationalUserBankAccountSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "InternationalUserBankAccountSchema": {
            "additionalProperties": false,
            "properties": {
                "account_number": {
                    "title": "Account Number",
                    "type": "string"
                },
                "account_type": {
                    "class_name": "BankAccountType",
                    "enum": [
                        "checking",
                        "savings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "international_user_bank_account"
                },
                "bank_name": {
                    "title": "Bank Name",
                    "type": "string"
                },
                "bic_swift_code": {
                    "title": "Bic Swift Code",
                    "type": "string"
                },
                "contact_phone_number": {
                    "title": "Contact Phone Number",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "first_name_on_account": {
                    "title": "First Name On Account",
                    "type": "string"
                },
                "internal_account_type": {
                    "class_name": "InternalUserBankAccountType",
                    "enum": [
                        "us_domestic",
                        "international"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_name_on_account": {
                    "title": "Last Name On Account",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "recipient_address_city": {
                    "title": "Recipient Address City",
                    "type": "string"
                },
                "recipient_address_state": {
                    "title": "Recipient Address State",
                    "type": "string"
                },
                "recipient_address_street": {
                    "title": "Recipient Address Street",
                    "type": "string"
                },
                "recipient_country": {
                    "title": "Recipient Country",
                    "type": "string"
                },
                "recipient_postal_code": {
                    "title": "Recipient Postal Code",
                    "type": "string"
                },
                "state": {
                    "class_name": "BankAccountState",
                    "enum": [
                        "not_in_use",
                        "in_use"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "user_deleted": {
                    "title": "User Deleted",
                    "type": "boolean"
                }
            },
            "required": [
                "account_number",
                "account_type",
                "account_uid",
                "bank_name",
                "bic_swift_code",
                "contact_phone_number",
                "first_name_on_account",
                "last_name_on_account",
                "recipient_address_city",
                "recipient_address_state",
                "recipient_address_street",
                "recipient_country",
                "recipient_postal_code"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PASSWORD_JSON_SCHEMA = {
    "$ref": "#/definitions/PasswordSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PasswordSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "password_hash": {
                    "title": "Password Hash",
                    "type": "string"
                },
                "password_salt": {
                    "title": "Password Salt",
                    "type": "string"
                },
                "password_version": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Password Version",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "last_updated_timestamp",
                "password_hash",
                "password_salt",
                "password_version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PASSWORD_RESET_JSON_SCHEMA = {
    "$ref": "#/definitions/PasswordResetSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PasswordResetSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "expires_timestamp": {
                    "format": "date-time",
                    "title": "Expires Timestamp",
                    "type": "string"
                },
                "last_sent_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Sent Email Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "reset_reason": {
                    "class_name": "ExpiredPasswordReason",
                    "enum": [
                        "password_reset",
                        "user_updated_password",
                        "admin_triggered_reset",
                        "admin_changed",
                        "mandatory_update"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "reset_token": {
                    "title": "Reset Token",
                    "type": "string"
                },
                "reset_uid": {
                    "reference_type": "uuid",
                    "title": "Reset Uid",
                    "type": "string",
                    "uid_resource_type": "password_reset"
                },
                "sent_email_count": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Sent Email Count",
                    "type": "number"
                },
                "token_hash": {
                    "title": "Token Hash",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "expires_timestamp",
                "last_sent_email_timestamp",
                "last_updated_timestamp",
                "reset_reason",
                "reset_token",
                "reset_uid",
                "sent_email_count",
                "token_hash"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PENDING_EMAIL_CHANGE_JSON_SCHEMA = {
    "$ref": "#/definitions/PendingEmailChangeSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PendingEmailChangeSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "change_uid": {
                    "reference_type": "uuid",
                    "title": "Change Uid",
                    "type": "string",
                    "uid_resource_type": "pending_email_change"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "last_sent_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Sent Email Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "sent_email_count": {
                    "format": "integer",
                    "maximum": 32766,
                    "minimum": -32766,
                    "title": "Sent Email Count",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "change_uid",
                "created_timestamp",
                "email_address",
                "email_hash",
                "last_sent_email_timestamp",
                "last_updated_timestamp",
                "sent_email_count"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PREVIOUS_EMAIL_ADDRESS_JSON_SCHEMA = {
    "$ref": "#/definitions/PreviousEmailAddressSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PreviousEmailAddressSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "previous_email_uid": {
                    "reference_type": "uuid",
                    "title": "Previous Email Uid",
                    "type": "string",
                    "uid_resource_type": "previous_email_address"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "email_address",
                "email_hash",
                "last_updated_timestamp",
                "previous_email_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _RELEASED_FUNDS_LOCK_JSON_SCHEMA = {
    "$ref": "#/definitions/ReleasedFundsLockSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ReleasedFundsLockSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "funds_lock_created_timestamp": {
                    "format": "date-time",
                    "title": "Funds Lock Created Timestamp",
                    "type": "string"
                },
                "funds_locked_last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Funds Locked Last Updated Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "lock_uid": {
                    "reference_type": "uuid",
                    "title": "Lock Uid",
                    "type": "string",
                    // "uid_resource_type": "funds_lock"
                },
                "locked_balance_source_list": {
                    "items": {
                        "title": "locked_balance_source_list",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Locked Balance Source List",
                    "type": "array",
                    "uid_resource_type": "user_account_balance_source"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "created_timestamp",
                "deposify_tags",
                "funds_lock_created_timestamp",
                "funds_locked_last_updated_timestamp",
                "last_updated_timestamp",
                "lock_uid",
                "locked_balance_source_list",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _THIRD_PARTY_USER_ACCOUNT_MAPPING_JSON_SCHEMA = {
    "$ref": "#/definitions/ThirdPartyUserAccountMappingSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ThirdPartyUserAccountMappingSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                }
            },
            "required": [
                "account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "create_in_organization_uid": {
                    "reference_type": "uuid",
                    "title": "Create In Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "default_role": {
                    "class_name": "UserAccountRoles",
                    "enum": [
                        "landlord",
                        "tenant",
                        "broker",
                        "mediator",
                        "admin",
                        "super_admin",
                        "sales_demo"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "title": "Email Hash",
                    "type": "string"
                },
                "email_verified": {
                    "title": "Email Verified",
                    "type": "boolean"
                },
                "eminent_organization_uid": {
                    "reference_type": "uuid",
                    "title": "Eminent Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                },
                "first_name": {
                    "maxLength": 32,
                    "minLength": 2,
                    "title": "First Name",
                    "type": "string"
                },
                "first_sign_in_timestamp": {
                    "format": "date-time",
                    "title": "First Sign In Timestamp",
                    "type": "string"
                },
                "has_pending_email_change": {
                    "title": "Has Pending Email Change",
                    "type": "boolean"
                },
                "last_name": {
                    "maxLength": 32,
                    "title": "Last Name",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "middle_name": {
                    "maxLength": 32,
                    "title": "Middle Name",
                    "type": "string"
                },
                "name_title": {
                    "maxLength": 32,
                    "title": "Title",
                    "type": "string"
                },
                "organization_uids": {
                    "items": {
                        "title": "organization_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "profile_pic_file_uid": {
                    "reference_type": "uuid",
                    "title": "Profile Pic File Uid",
                    "type": "string",
                    "uid_resource_type": "storage_file"
                },
                "roles": {
                    "items": {
                        "class_name": "UserAccountRoles",
                        "enum": [
                            "landlord",
                            "tenant",
                            "broker",
                            "mediator",
                            "admin",
                            "super_admin",
                            "sales_demo"
                        ],
                        "reference_type": "enum",
                        "type": "string"
                    },
                    "title": "Roles",
                    "type": "array"
                },
                "state": {
                    "class_name": "UserAccountState",
                    "enum": [
                        "active",
                        "banned",
                        "awaiting_finalization",
                        "deactivated"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "username": {
                    "maxLength": 32,
                    "minLength": 2,
                    "title": "Username",
                    "type": "string"
                },
                "partner_global_bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Partner Bank Account",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "partner_global_bank_account_disabled": {
                    "title": "Partner Bank Account Disabled",
                    "type": "boolean"
                }
            },
            "required": [
                "create_in_organization_uid",
                "default_role",
                "email_address",
                "email_hash",
                "eminent_organization_uid",
                "first_name",
                "last_name",
                "roles",
                "username"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_BALANCE_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountBalanceSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountBalanceSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "free_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Free Balance In Cents",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "locked_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Locked Balance In Cents",
                    "type": "number"
                },
                "total_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Total Balance In Cents",
                    "type": "number"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "free_balance_in_cents",
                "last_updated_timestamp",
                "locked_balance_in_cents",
                "total_balance_in_cents"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_BALANCE_SOURCE_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountBalanceSourceSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountBalanceSourceSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "awaiting_balance_source_transfer": {
                    "title": "Awaiting Balance Source Transfer",
                    "type": "boolean"
                },
                "balance_source_transfer_uid": {
                    "reference_type": "uuid",
                    "title": "Balance Source Transfer Uid",
                    "type": "string",
                    "uid_resource_type": "balance_source_transfer"
                },
                "balance_type": {
                    "class_name": "UserAccountBalanceType",
                    "enum": [
                        "free_balance",
                        "locked_balance"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "source_uid": {
                    "reference_type": "uuid",
                    "title": "Source Uid",
                    "type": "string",
                    "uid_resource_type": "user_account_balance_source"
                }
            },
            "required": [
                "account_uid",
                "amount_in_cents",
                "awaiting_balance_source_transfer",
                "balance_source_transfer_uid",
                "balance_type",
                "created_timestamp",
                "funds_location",
                "funds_location_uid",
                "last_updated_timestamp",
                "source_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_FINALIZATION_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountFinalizationSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountFinalizationSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "expires_timestamp": {
                    "format": "date-time",
                    "title": "Expires Timestamp",
                    "type": "string"
                },
                "first_email_timestamp": {
                    "format": "date-time",
                    "title": "First Email Timestamp",
                    "type": "string"
                },
                "last_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Email Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "name_needed_for_finalization": {
                    "title": "Name Needed For Finalization",
                    "type": "boolean"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "phone_needed_for_finalization": {
                    "title": "Phone Needed For Finalization",
                    "type": "boolean"
                },
                "sent_email_count": {
                    "format": "integer",
                    "title": "Sent Email Count",
                    "type": "number"
                },
                "state": {
                    "class_name": "UserAccountFinalizationState",
                    "enum": [
                        "active",
                        "expired"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "verification_token": {
                    "title": "Verification Token",
                    "type": "string"
                },
                "verification_token_hash": {
                    "title": "Verification Token Hash",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "expires_timestamp",
                "first_email_timestamp",
                "last_email_timestamp",
                "name_needed_for_finalization",
                "phone_needed_for_finalization",
                "sent_email_count",
                "state",
                "verification_token",
                "verification_token_hash"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_ACCOUNT_SETTINGS_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAccountSettingsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAccountSettingsSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "allow_self_deposit": {
                    "title": "Allow Self Deposit",
                    "type": "boolean"
                },
                "always_show_archived_deposits": {
                    "title": "Always Show Archived Deposits",
                    "type": "boolean"
                },
                "auto_archive_cancelled_deposits": {
                    "title": "Auto Archive Cancelled Deposits",
                    "type": "boolean"
                },
                "auto_archive_cancelled_deposits_day_count": {
                    "format": "integer",
                    "title": "Auto Archive Cancelled Deposits Day Count",
                    "type": "number"
                },
                "auto_archive_closed_deposits": {
                    "title": "Auto Archive Closed Deposits",
                    "type": "boolean"
                },
                "auto_archive_closed_deposits_day_count": {
                    "format": "integer",
                    "title": "Auto Archive Closed Deposits Day Count",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "date_display_format": {
                    "title": "Date Display Format",
                    "type": "string"
                },
                "default_us_state": {
                    "title": "Default Us State",
                    "type": "string"
                },
                "deposit_listing_click_header_to_expand": {
                    "title": "Deposit Listing Click Header To Expand",
                    "type": "boolean"
                },
                "deposit_listing_opens_fullscreen": {
                    "title": "Deposit Listing Opens Fullscreen",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "recent_us_states": {
                    "items": {
                        "title": "recent_us_states",
                        "type": "string"
                    },
                    "title": "Recent Us States",
                    "type": "array"
                },
                "show_extended_create_deposit_form": {
                    "title": "Show Extended Create Deposit Form",
                    "type": "boolean"
                },
                "show_local_time": {
                    "title": "Show Local Time",
                    "type": "boolean"
                },
                "show_properties_listing": {
                    "title": "Show Properties Listing",
                    "type": "boolean"
                },
                "show_welcome_message": {
                    "title": "Show Welcome Message",
                    "type": "boolean"
                },
                "show_yardi_voyager_integration": {
                    "title": "Show Yardi Voyager Integration",
                    "type": "boolean"
                }
            },
            "required": [
                "account_uid",
                "allow_self_deposit",
                "always_show_archived_deposits",
                "auto_archive_cancelled_deposits",
                "auto_archive_cancelled_deposits_day_count",
                "auto_archive_closed_deposits",
                "auto_archive_closed_deposits_day_count",
                "created_timestamp",
                "date_display_format",
                "default_us_state",
                "deposit_listing_click_header_to_expand",
                "deposit_listing_opens_fullscreen",
                "last_updated_timestamp",
                "recent_us_states",
                "show_extended_create_deposit_form",
                "show_local_time",
                "show_properties_listing",
                "show_welcome_message",
                "show_yardi_voyager_integration"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_BANK_ACCOUNT_DELTA_JSON_SCHEMA = {
    "$ref": "#/definitions/UserBankAccountDeltaSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserBankAccountDeltaSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "delta_uid": {
                    "reference_type": "uuid",
                    "title": "Delta Uid",
                    "type": "string",
                    "uid_resource_type": "user_bank_account_delta"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "payload": {
                    "additionalProperties": {},
                    "title": "Payload",
                    "type": "object"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "update_delta_type": {
                    "class_name": "DeltaType",
                    "enum": [
                        "initial_snapshot",
                        "update"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "delta_uid",
                "last_updated_timestamp",
                "payload",
                "resource_type",
                "resource_uid",
                "update_delta_type"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _US_DOMESTIC_USER_BANK_ACCOUNT_JSON_SCHEMA = {
    "$ref": "#/definitions/USDomesticUserBankAccountSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "USDomesticUserBankAccountSchema": {
            "additionalProperties": false,
            "properties": {
                "account_number": {
                    "title": "Account Number",
                    "type": "string"
                },
                "account_type": {
                    "class_name": "BankAccountType",
                    "enum": [
                        "checking",
                        "savings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "ach": {
                    "title": "Ach",
                    "type": "string"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "us_domestic_user_bank_account"
                },
                "bank_name": {
                    "title": "Bank Name",
                    "type": "string"
                },
                "contact_phone_number": {
                    "title": "Contact Phone Number",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "first_name_on_account": {
                    "title": "First Name On Account",
                    "type": "string"
                },
                "internal_account_type": {
                    "class_name": "InternalUserBankAccountType",
                    "enum": [
                        "us_domestic",
                        "international"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "last_name_on_account": {
                    "title": "Last Name On Account",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "state": {
                    "class_name": "BankAccountState",
                    "enum": [
                        "not_in_use",
                        "in_use"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "user_deleted": {
                    "title": "User Deleted",
                    "type": "boolean"
                }
            },
            "required": [
                "account_number",
                "account_type",
                "account_uid",
                "ach",
                "bank_name",
                "contact_phone_number",
                "first_name_on_account",
                "last_name_on_account"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const ADMIN_GHOST_USER_ACCOUNT_JSON_SCHEMA = _ADMIN_GHOST_USER_ACCOUNT_JSON_SCHEMA.definitions.AdminGhostUserAccountSchema;
export const ARCHIVED_PENDING_EMAIL_CHANGE_JSON_SCHEMA = _ARCHIVED_PENDING_EMAIL_CHANGE_JSON_SCHEMA.definitions.ArchivedPendingEmailChangeSchema;
export const BALANCE_CHANGE_LOG_JSON_SCHEMA = _BALANCE_CHANGE_LOG_JSON_SCHEMA.definitions.BalanceChangeLogSchema;
export const BALANCE_SOURCE_TRANSFER_JSON_SCHEMA = _BALANCE_SOURCE_TRANSFER_JSON_SCHEMA.definitions.BalanceSourceTransferSchema;
export const CREDIT_USER_ACCOUNT_LOG_JSON_SCHEMA = _CREDIT_USER_ACCOUNT_LOG_JSON_SCHEMA.definitions.CreditUserAccountLogSchema;
export const EMAIL_VERIFICATION_JSON_SCHEMA = _EMAIL_VERIFICATION_JSON_SCHEMA.definitions.EmailVerificationSchema;
export const EMAIL_VERIFICATION_RECORD_JSON_SCHEMA = _EMAIL_VERIFICATION_RECORD_JSON_SCHEMA.definitions.EmailVerificationRecordSchema;
export const EXPIRED_PASSWORD_JSON_SCHEMA = _EXPIRED_PASSWORD_JSON_SCHEMA.definitions.ExpiredPasswordSchema;
export const FUNDS_LOCK_JSON_SCHEMA = _FUNDS_LOCK_JSON_SCHEMA.definitions.FundsLockSchema;
export const FUNDS_LOCK_RELEASE_LOG_JSON_SCHEMA = _FUNDS_LOCK_RELEASE_LOG_JSON_SCHEMA.definitions.FundsLockReleaseLogSchema;
export const INTERNATIONAL_USER_BANK_ACCOUNT_JSON_SCHEMA = _INTERNATIONAL_USER_BANK_ACCOUNT_JSON_SCHEMA.definitions.InternationalUserBankAccountSchema;
export const PASSWORD_JSON_SCHEMA = _PASSWORD_JSON_SCHEMA.definitions.PasswordSchema;
export const PASSWORD_RESET_JSON_SCHEMA = _PASSWORD_RESET_JSON_SCHEMA.definitions.PasswordResetSchema;
export const PENDING_EMAIL_CHANGE_JSON_SCHEMA = _PENDING_EMAIL_CHANGE_JSON_SCHEMA.definitions.PendingEmailChangeSchema;
export const PREVIOUS_EMAIL_ADDRESS_JSON_SCHEMA = _PREVIOUS_EMAIL_ADDRESS_JSON_SCHEMA.definitions.PreviousEmailAddressSchema;
export const RELEASED_FUNDS_LOCK_JSON_SCHEMA = _RELEASED_FUNDS_LOCK_JSON_SCHEMA.definitions.ReleasedFundsLockSchema;
export const THIRD_PARTY_USER_ACCOUNT_MAPPING_JSON_SCHEMA = _THIRD_PARTY_USER_ACCOUNT_MAPPING_JSON_SCHEMA.definitions.ThirdPartyUserAccountMappingSchema;
export const USER_ACCOUNT_JSON_SCHEMA = _USER_ACCOUNT_JSON_SCHEMA.definitions.UserAccountSchema;
export const USER_ACCOUNT_BALANCE_JSON_SCHEMA = _USER_ACCOUNT_BALANCE_JSON_SCHEMA.definitions.UserAccountBalanceSchema;
export const USER_ACCOUNT_BALANCE_SOURCE_JSON_SCHEMA = _USER_ACCOUNT_BALANCE_SOURCE_JSON_SCHEMA.definitions.UserAccountBalanceSourceSchema;
export const USER_ACCOUNT_FINALIZATION_JSON_SCHEMA = _USER_ACCOUNT_FINALIZATION_JSON_SCHEMA.definitions.UserAccountFinalizationSchema;
export const USER_ACCOUNT_SETTINGS_JSON_SCHEMA = _USER_ACCOUNT_SETTINGS_JSON_SCHEMA.definitions.UserAccountSettingsSchema;
export const USER_BANK_ACCOUNT_DELTA_JSON_SCHEMA = _USER_BANK_ACCOUNT_DELTA_JSON_SCHEMA.definitions.UserBankAccountDeltaSchema;
export const US_DOMESTIC_USER_BANK_ACCOUNT_JSON_SCHEMA = _US_DOMESTIC_USER_BANK_ACCOUNT_JSON_SCHEMA.definitions.USDomesticUserBankAccountSchema;
